module.exports = __webpack_public_path__ + "static/media/document-text.fdc41c5e.svg";